import {useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { getUploadedFiles, uploadFile, deleteFile, viewFile } from '../../utils/api';
import { validateEntry } from '../../utils/validation';
import PasswordRulesModal from '../Password/PasswordRulesModal';
import PatDocs from '../PatDocs/Documents';
import classes from  '../Register/Register.module.css';
import { useUpload  } from "../../store/UploadContext";

const FormHelper 	= (props) => {
	const TF=props.TF;
	const userdata=props.data;
	const { uploadedFileName, handleSelectedFile, storeFile, uploadOne, pendingFileName, clearPending } = useUpload();
	const token=sessionStorage.getItem("token");
	const navigate = useNavigate();
	const [error, setError] = useState({});
	const pwd = useRef(null);
	const verify = useRef(null);
	const email = useRef(null);
	const emailverify = useRef(null);
	const [doPasswordsMatch, setDoPasswordsMatch] = useState(true);
	const [doEmailsMatch, setDoEmailsMatch] = useState(true);
	const [rules, setRules] = useState(false);
	const [fileStruc, setFileStruc] = useState([]);
	const [filenameList, setFilenameList] = useState('');
	const [didEdit, setDidEdit] = useState({
		Password: false,
		Confirmpassword: false,
	});
	useEffect(() =>{
		props.onTF(error);
	},[error]);
	
	const getStyleObjectFromString = (str) => {
	  const style = {};
	  str.split(";").forEach(el => {
		const [property, value] = el.split(":");
		if (!property) return;

		style[property] = value.trim();
	  });

	  return style;
	};
	
	const [dobvalue, setDobvalue] = useState('');
	const handleDOB = (e) => {
	  let input = e.target.value.replace(/\D/g, ''); // Remove all non-digits

	  if (input.length > 8) {
		input = input.slice(0, 8); // Limit to 8 digits max
	  }

	  if (input.length >= 5) {
		input = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4)}`;
	  } else if (input.length >= 3) {
		input = `${input.slice(0, 2)}/${input.slice(2)}`;
	  }

	  setDobvalue(input);
	};
	

	const validationHandler = (event) => {
		const validationType = event.target.dataset.validation;
		const valstring = event.target.value;
		const valerror=validateEntry(validationType,valstring);
		const fldname=event.target.name;
		if(fldname==='new-password' && valerror ==='') {
			confirmPassword(event);
		}else{
			if(valerror!=='') {
				setError(prevState => ({...prevState,[fldname]:valerror,}));
			}else{
				var newError={...error};
				delete newError[event.target.name];
				setError(newError);	
			}
		}
	};
	const formatPhoneText = (value)=>{
	  value = value.replaceAll("-","");
	  if(value.length > 3 && value.length <= 6) 
		value = value.slice(0,3) + "-" + value.slice(3);
	  else if(value.length > 6) 
		value = value.slice(0,3) + "-" + value.slice(3,6) + "-" + value.slice(6);
	  
	  return value;
	};
	const validatePhone= (p)=>{
	  var phoneRe = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/;
	  var digits = p.replace(/\D/g, "");
	  return phoneRe.test(digits);
		}
		const toggleRules = () =>{
			setRules(!rules);
	};
	const onKeyUpHandler = (e) =>{
	  var input = e.target;
	  var formatted = formatPhoneText(input.value);
	  input.value = formatted;
	};
	const confirmPassword =  event => {

		if (pwd.current.value === verify.current.value || !didEdit.Confirmpassword  || !didEdit.Password) {
				setDoPasswordsMatch(true);
				var newError={...error};
				delete newError['new-password'];
				setError(newError);	
			}
		else {
			setDoPasswordsMatch(false);
			const valerror="Passwords must match";
			const fldname='new-password';
			setError(prevState => ({...prevState,[fldname]:valerror,}));
		}
	}
	function onChangeHandler (identifier) {
		setDidEdit(prevEdit => ({...prevEdit,[identifier]: true}));
	}

	const confirmEmail =  event => {
		if (email.current.value === emailverify.current.value && email.current.value !== '') {
				setDoEmailsMatch(true);
				var newError={...error};
				delete newError[event.target.name];
				delete newError['Confirmnew-email'];
				setError(newError);	
			}
		else {
			setDoEmailsMatch(false);
			const valerror="Emails must match";
			const fldname=event.target.name;
			setError(prevState => ({...prevState,[fldname]:valerror,}));
		}
	}
	
	useEffect(() => { fetchDocuments(); }, []);
	
	  const fetchDocuments = async () => {
		  if (!token) return;

		  try {
			const data = await getUploadedFiles();
			setFileStruc(data);
			setFilenameList(data?.map(f => f.ClientFilename).join("; ") || "");
		  } catch (err) {
			console.error(err);
		  }
		};

	
	  const handleDelete = async (fileid, filename) => {
		try {
		  const confirmed = window.confirm(`Deleting ${filename}. Continue?`);
		  if (!confirmed) return;

		  await deleteFile(fileid);

		  // remove immediately from state
		  setFileStruc((prev) => prev.filter((file) => file.ID !== fileid));
		} catch (err) {
		  console.error(err);
		}
	  };

	  const handleView = async (filedata) => {
		try {
		  const filename =  filedata.ClientFilename;
		  await viewFile(filename);
		} catch (err) {
		  alert(err.message);
		}
	  };

	const Elements = TF.map((element) => {
		let elementID=element.TFOrder;
		if(typeof elementID === 'undefined'){
			elementID=element.SortOrder;
		}
		let elRequire= '';
		if (element.Required === 1 || element.Required === true) {
			elRequire=1;
		}
		let startValue=''
		if(element.Name === 'ActivationCode' && props.urlvalue!=='') {
			startValue = props.urlvalue;
		}else if(sessionStorage.getItem(element.DBColumn) !== '' && sessionStorage.getItem(element.DBColumn) !== null ) {
			// console.log(sessionStorage.getItem(element.DBColumn));
			startValue = sessionStorage.getItem(element.DBColumn);
			element.Editible=false;
		}else if(userdata !== undefined && userdata[element.DBColumn] !== undefined) {
			startValue = userdata[element.DBColumn];
		}else if (userdata !== undefined && userdata[elementID-1] !== undefined) {
			startValue = userdata[elementID-1];
		}
		let addinfo=""
		if (element.AdditionalInfo !== undefined) {
			addinfo = JSON.parse(element.AdditionalInfo);
		}
		const tftype=addinfo?.type;
		let tfcssString=addinfo?.style;
		let tfcss={};
		if (tfcssString !== undefined) tfcss=getStyleObjectFromString(tfcssString);

		if (element.FieldType === undefined && tftype !== undefined) element.FieldType=tftype;
		if (element.FieldType === undefined ) element.FieldType="text";
		const isEditable = element.Editible ?? true;

		switch(element.FieldType) {
					case 'select':
					case 'Select':
						if(startValue===''){
							return (
								<div key={elementID} className={classes['form-control']}>
									<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
									<select name={element.Name} id={element.DBColumn} required={elRequire} >
										<option key='0' value=''>--Select--</option>
										{element.Select.map((dd) => 
											<option key={dd.Value} value={dd.Value} >{dd.Description}</option>
										)}
									</select>
								</div>
								);
						}else{
							return (
							<>
								{isEditable && 
								<div key={elementID} className={classes['form-control']}>
									<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
									<select name={element.Name} id={element.DBColumn} required={elRequire} defaultValue={startValue} >
										<option key='0' value=''>--Select--</option>
											{element.Select.map((dd) => 
												<option key={dd.Value} value={dd.Value} >{dd.Description}</option>
											)}
									
									</select>
								</div>
								}
								{!isEditable && <div key={elementID} className={classes['form-control']}>
									<label htmlFor={elementID}>{element.Label}{elRequire && '*'}</label>
									<div style={tfcss} dangerouslySetInnerHTML={{__html: startValue}} />
								</div>
								}
							</>
							);
						}
					case 'List':
						if(startValue===''){
							return (
								<div key={elementID} className={classes['form-control']}> **multiple selection does not currently work**
									<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
									<select name={element.Name} id={element.DBColumn} required={elRequire}  >
									<option key='0' value=''>--Select--</option>
										{element.Select.map((dd) => 
											<option key={dd.Value} value={dd.Value}>{dd.Description}</option>
										)}
									</select>
								</div>
								);
						}else{
							return (
								<div key={elementID} className={classes['form-control']}>**multiple selection does not currently work**
									<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
									<select name={element.Name} id={element.DBColumn} required={elRequire} defaultValue={startValue} >
									<option key='0' value=''>--Select--</option>
											{element.Select.map((dd) => 
												<option key={dd.Value} value={dd.Value}>{dd.Description}</option>
											)}
									
									</select>
								</div>
								);

						}
					case 'Checkbox':
						if(startValue===''){
							return (
								<div key={elementID} className={classes['form-control']}>**multiple selection does not currently work**
									<label htmlFor={element.Name}>{element.Label}{elRequire && '*'}</label>
									{element.Select.map((dd) => 
									<>
										&nbsp;&nbsp;<input type="checkbox" key={dd.Value} name={element.Name} value={dd.Value} required={elRequire} />&nbsp;{dd.Description}
									</>
									)}
								</div>
								);
						}else{
							return (
								<div key={elementID} className={classes['form-control']}>**multiple selection does not currently work**
									<label htmlFor={element.Name}>{element.Label}{elRequire && '*'}</label>
									{element.Select.map((dd) => 
									 <>	
										&nbsp;&nbsp;<input type="checkbox" key={dd.Value}  name={element.Name} value={dd.Value} required={elRequire} defaultChecked={dd.Value===startValue} />&nbsp;{dd.Description}
									  </>
									)}
								</div>
								);

						}
					case 'Radio':
							return (
								<div key={elementID} className={classes['form-control']}>
								  <label htmlFor={elementID}>
									{element.Label}
									{elRequire && '*'}
								  </label>

									{element.Select.map((dd) => {
									  const radioId = `${element.Name}_${dd.Value}`;
									  return (
										<div
										  key={dd.Value}
										  style={{
											display: 'flex',
											alignItems: 'center',
											 marginBottom: '0.5rem',
										  }}
										>
										  <input
											type="radio"
											id={radioId}
											name={element.Name}
											value={dd.Value}
											required={elRequire}
											className={classes['customRadio']}
											defaultChecked={startValue !== '' ? dd.Value === startValue : undefined}
										  />
										  <label htmlFor={radioId} 
										    style={{
												marginLeft: '8px',
												fontSize: '14px',
												lineHeight: '16px',
												display: 'inline-block',
												cursor: 'pointer',
												height: '16px',
												alignItems:'center',
												marginTop: '6px',
											  }}>
											{dd.Description}
										  </label>
										</div>
									  );
									})}


								</div>

							);
						
					case 'Date':
							return (
							<div key={elementID} className={classes['form-control']}>
								<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
								<input type='date' name={element.Name} id={element.DBColumn} required={elRequire} 
								 onBlur={validationHandler}
								 defaultValue={startValue || undefined}
								/>
								{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
							</div>
							);
					case 'DOB':
						if(startValue==='') {
							return (
							<div key={elementID} className={classes['form-control']}>
								<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
								<input type='text' name={element.Name} id={element.DBColumn} required={elRequire} 
								 data-validation='validateDOB' onBlur={validationHandler} placeholder='MM/DD/YYYY'
								 onChange={handleDOB} value={dobvalue}
								/>
								{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
							</div>
							);
						}else{
							return (
							<div key={elementID} className={classes['form-control']}>
								<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
								<input type='text' name={element.Name} id={element.DBColumn} required={elRequire} 
								value={startValue}  data-validation='validateDOB' onBlur={validationHandler}
								onChange={handleDOB}
								/>
								{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
							</div>
							);
						}
					case 'PHONE':  
						return (
							<div key={elementID} className={classes['form-control']}>
								<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
								<input type='text' name={element.Name} id={element.DBColumn} required={elRequire} 
								data-validation='validatePhone' onBlur={validationHandler}
								onKeyUp={onKeyUpHandler}
								defaultValue={startValue || undefined}
								/>
								{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
							</div>
							);
					case 'password':
						return(
							<div key={elementID} className={classes['form-control']}>
								<label htmlFor='new-password'>{element.Label}{elRequire && '*'}</label>
								<input ref={pwd} autoComplete="new-password" type='password' name='new-password' id='new-password' required={elRequire}  
									onBlur={validationHandler} data-validation='validatePassword' onChange={() => onChangeHandler('Password')}
								/>
								{error['new-password']&& <div className={classes.error}>{error['new-password']}</div>}
								<label htmlFor='Confirmnew-password'>Confirm {element.Label}{elRequire && '*'}</label>
								<input autoComplete="new-password" type='password' ref={verify} name='Confirmnew-password' id='Confirmnew-password' required={elRequire}  
								  onBlur={confirmPassword}  onChange={() => onChangeHandler('Confirmpassword')}
								/>
								<button onClick={toggleRules} type="button">Password Rules</button>
								{rules && <PasswordRulesModal onClose={toggleRules}/>}
							</div>
						);

					case 'CURRENCY':
						return (
							<div key={elementID} className={classes['form-control']}>
										<label htmlFor={elementID}>{element.Label}{elRequire && '*'}</label>
										<div style={tfcss}>${startValue}</div>
							</div>
						);
					case 'File':
					case 'filename':
						  return (
							<div key={elementID} className={classes['form-control']}>
							  <label htmlFor={elementID}>
								{element.Label}
								{elRequire && '*'}
							  </label>

							  <input
									  id={elementID}
									  type="file"
									  required={elRequire}
									  onChange={async (e) => {
										const file = e.target.files?.[0] || null;
										if (!file) return;

										// store always
										storeFile(element.Name, file);

										// instant upload if token exists
										const token = sessionStorage.getItem("token");
										if (token) {
										  const didUpload = await uploadOne(element.Name);
										  if (didUpload) {
											await fetchDocuments();
											//e.target.value = ""; // clear only after upload
										  }
										}
										// if no token: DO NOT clear input if you want browser to show selected
									  }}
									/>
								{pendingFileName?.[element.Name] && !uploadedFileName?.[element.Name] && (
								  <div>Stored: {pendingFileName[element.Name]} (uploads after login)</div>
								)}

								{uploadedFileName?.[element.Name] && (
								  <div>Uploaded: {uploadedFileName[element.Name]}</div>
								)}
								{token && (
									  <PatDocs
										files={fileStruc}
										onView={handleView}
										onDelete={handleDelete}
									  />
								)}
								</div>
						  );
					case 'Memo':
						return (
							<>
								<div>
								  {isEditable && <div key={elementID} className={classes['form-control']}>
										<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
										<textarea name={element.Name} id={element.DBColumn} rows='4' cols='50' required={elRequire}
											defaultValue={startValue || undefined}
											/>
											{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
									</div>
									  }
								</div>
								<div>
									  {!isEditable && <div key={elementID} className={classes['form-control']}>
											<label htmlFor={elementID}>{element.Label}{elRequire && '*'}</label>
											<div style={tfcss} dangerouslySetInnerHTML={{__html: startValue}} />
										</div>
									  }
								</div>
							</> 
						);
					default:
							if(element.SelectType !== "validateConfirmEmail") {
								return (
								<>
								  <div>
								  {isEditable &&
									<div key={elementID} className={classes['form-control']}>
										<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
										<input type='text' name={element.Name} id={element.DBColumn} onBlur={validationHandler} required={elRequire} defaultValue={startValue || undefined}  
										   data-validation={element.SelectType} 
										/>
										{error[element.Name] && <div className={classes.error}>{error[element.Name]}</div>}
									</div>
								  }
								  {!isEditable && <div key={elementID} className={classes['form-control']}>
										<label htmlFor={elementID}>{element.Label}{elRequire && '*'}</label>
										<div style={tfcss} dangerouslySetInnerHTML={{__html: startValue}} />
									</div>
								  }
								  </div>
								 </> 
								 );
							}else{
								return (
									<div key={elementID} className={classes['form-control']}>
										<label htmlFor={element.DBColumn}>{element.Label}{elRequire && '*'}</label>
										<input type='text' ref={email} name={element.Name} id={element.DBColumn} onBlur={validationHandler} required={elRequire}  defaultValue={startValue || undefined}
										   data-validation={element.SelectType}
										/>
										{error[element.Name]&& <div className={classes.error}>{error[element.Name]}</div>}
										<label htmlFor={element.DBColumn}>Confirm {element.Label}{elRequire && '*'}</label>
										<input type='text' ref={emailverify} name={element.Name} id={element.DBColumn} onBlur={confirmEmail} required={elRequire}  
										   data-validation={element.SelectType} 
										/>
									</div>
								);
							}
		}
		})
    return (
	<div>{Elements}</div>
	);
};
	
export default FormHelper;
